import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Select, Button } from 'antd';

function AddForm({ formRef, onFinish, initialValues = {}, isLoading = false }) {  
  const [imageSrc, setImageSrc] = useState([]);
  const [imageSrcChoice, setImageSrcChoice] = useState([]);
  const textareaRef = useRef(null);

  // Reset form and images
  const resetForm = () => {
    formRef.current?.resetFields();
    setImageSrc([]);
    setImageSrcChoice([]);
  };

  // Expose reset function to parent
  React.useImperativeHandle(formRef, () => ({
    resetFields: resetForm,
    validateFields: formRef.current?.validateFields,
    getFieldValue: formRef.current?.getFieldValue,
  }));

  // Reset form when modal closes
  useEffect(() => {
    if (!isLoading && formRef.current) {
      // Reset form when not loading (after successful submit)
      const timer = setTimeout(() => {
        resetForm();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  const handlePaste = (e) => {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') !== -1) {
        const file = items[i].getAsFile();
        const reader = new FileReader();
        reader.onload = (event) => {
          setImageSrc(prev => [...prev, event.target.result]);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleChoicePaste = (e) => {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') !== -1) {
        const file = items[i].getAsFile();
        const reader = new FileReader();
        reader.onload = (event) => {
          setImageSrcChoice(prev => [...prev, event.target.result]);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await formRef.current.validateFields();
      const payload = {
        ...values,
        images: imageSrc,
        imagesChoice: imageSrcChoice,
      };
      console.log('AddForm payload:', payload);
      await onFinish?.(payload);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Form ref={formRef} layout="vertical" initialValues={initialValues}>
              <Form.Item
                name="user"
                label="User"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input maxLength={100} placeholder="UserId" />
              </Form.Item>
              <Form.Item
                name="case"
                label="Case"
                rules={[{ required: true, message: "Please select case!" }]}
              >
                <Select>
                  {/* <Select.Option value="deposit">Deposit</Select.Option>
                  <Select.Option value="withdraw">Withdraw</Select.Option>
                  <Select.Option value="ETC">ETC.</Select.Option> */}
                  <Select.Option value="Panel">Panel</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item 
                name="images" 
                label="รูปภาพ(receipt)"
                dependencies={['case']}
                rules={[
                  { 
                    required: false, 
                    validator: (_, value) => {
                      const caseValue = formRef.current?.getFieldValue('case');
                      if (caseValue === 'deposit' && imageSrc.length === 0) {
                        return Promise.reject(new Error('กรุณาอัพโหลดรูปภาพ Receipt สำหรับ Deposit'));
                      }
                      return Promise.resolve();
                    }
                  }
                ]}
              >
                <div>
                  <textarea
                    ref={textareaRef}
                    placeholder="กด Ctrl+V เพื่อวางรูป"
                    onPaste={handlePaste}
                    rows={2}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                    }}
                  />
                  {imageSrc.length > 0 && (
                    <>
                      <div className="mt-2 mb-1">
                        <strong>Preview รูป:</strong>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {imageSrc.map((src, index) => (
                          <div
                            key={index}
                            style={{ width: "100px", position: "relative" }}
                          >
                            <Button
                              type="text"
                              danger
                              style={{
                                position: "absolute",
                                top: -10,
                                right: -10,
                                padding: 0,
                                minWidth: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "white",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                              }}
                              onClick={() => {
                                const newImageSrc = [...imageSrc];
                                newImageSrc.splice(index, 1);
                                setImageSrc(newImageSrc);
                              }}
                            >
                              ×
                            </Button>
                            <img
                              src={src}
                              alt="pasted"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </Form.Item>

              <Form.Item
                name="imagesChoice"
                label="รูปภาพ(เสริม)"
                required={false}
              >
                <div>
                  <textarea
                    ref={textareaRef}
                    placeholder="กด Ctrl+V เพื่อวางรูป"
                    onPaste={handleChoicePaste}
                    rows={2}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                    }}
                  />
                  {imageSrcChoice.length > 0 && (
                    <>
                      <div className="mt-2 mb-1">
                        <strong>Preview รูป:</strong>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {imageSrcChoice.map((src, index) => (
                          <div
                            key={index}
                            style={{ width: "100px", position: "relative" }}
                          >
                            <Button
                              type="text"
                              danger
                              style={{
                                position: "absolute",
                                top: -10,
                                right: -10,
                                padding: 0,
                                minWidth: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "white",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                              }}
                              onClick={() => {
                                const newImageSrc = [...imageSrcChoice];
                                newImageSrc.splice(index, 1);
                                setImageSrcChoice(newImageSrc);
                              }}
                            >
                              ×
                            </Button>
                            <img
                              src={src}
                              alt="pasted"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </Form.Item>

              <Form.Item name="note" label="Note">
                <Input.TextArea rows={4} placeholder="Enter Note" />
              </Form.Item>
              <Button
                type="primary"
                onClick={handleSubmit}
                loading={isLoading}
                block
              >
                เพิ่ม
              </Button>
            </Form>
  );
}

export default AddForm;

